import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setAdminToken } from "../lib/api";

const AdminLogin = () => {
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { username: u, password: p });
      setAdminToken(r.data.token);
      toast.success("Access granted");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen text-white flex items-center justify-center px-6 grid-bg relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#050505]" />
      <div className="relative w-full max-w-md border border-zinc-800 bg-[#0a0a0a] p-10" data-testid="admin-login-form">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#d4af37] mb-3">// RESTRICTED_ACCESS</div>
        <h1 className="font-display text-3xl mb-2">ADMIN TERMINAL</h1>
        <p className="text-xs text-zinc-500 mb-8 font-mono">RAW COMPANY / AUTH_REQUIRED</p>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="label-raw">Username</label>
            <input
              data-testid="admin-username"
              className="input-raw"
              value={u}
              onChange={(e) => setU(e.target.value)}
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
              required
            />
          </div>
          <div>
            <label className="label-raw">Password</label>
            <input
              data-testid="admin-password"
              className="input-raw"
              type="password"
              value={p}
              onChange={(e) => setP(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="btn-raw btn-raw-primary w-full py-4"
          >
            {loading ? "AUTHENTICATING..." : "→ ENTER"}
          </button>
        </form>
        <div className="mt-6 text-[9px] tracking-[0.3em] uppercase text-zinc-700 text-center">
          UNAUTHORIZED ACCESS IS LOGGED
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
